const SCRAPED_ITEM_ANALYSIS_SEVERITY = {
  INFORMATION: 'Information',
  WARNING: 'Warning',
  ERROR: 'Error',
}

export default SCRAPED_ITEM_ANALYSIS_SEVERITY
